import { $, $$ } from 'utils/dom';
import { fadeInFromBottom } from './animations';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { DrawSVGPlugin } from 'gsap/DrawSVGPlugin';
import { ScrollToPlugin } from 'gsap/ScrollToPlugin';
import { SplitText } from 'gsap/SplitText';

import { storyJumpmarks } from './story-jumpmarks/story-jumpmarks';
import { storyHeader } from './story-header/story-header';
import { storyHero } from './story-hero/story-hero';
import { storyHeadline } from './story-headline/story-headline';
import { storyTeaser } from './story-teaser/story-teaser';
import { storySection } from './story-section/story-section';
import { storyQuote } from './story-quote/story-quote';
import { storyChat } from './story-chat/story-chat';
import { storyImageText } from './story-image-text/story-image-text';
import { storyBanners } from './story-banner/story-banner';
import { storyGallery } from './story-gallery/story-gallery';
import { storyTextmedia } from './story-textmedia/story-textmedia';
import { storySplitscreen } from './story-splitscreen/story-splitscreen';
import { storyCta } from './story-cta-teaser/story-cta-teaser';
import { storyHighlights } from './story-highlights/story-highlights';
import { storyQuotes } from './story-quotes/story-quotes';
import { storyFacts } from './story-facts/story-facts';
import { storyImage } from './story-image/story-image';
import { storyVideo } from './story-video/story-video';

const story = $('.story');

if (story) {
  gsap.registerPlugin(ScrollTrigger, DrawSVGPlugin, ScrollToPlugin, SplitText);

  storyJumpmarks();
  storyHeader();
  storyHero();
  storyHeadline();
  storyTeaser();
  storySection();
  storyQuote();
  storyChat();
  storyImageText();
  storyBanners();
  storyGallery();
  storyTextmedia();
  storySplitscreen();
  storyCta();
  storyHighlights();
  storyQuotes();
  storyFacts();
  storyImage();
  storyVideo();

  const animatedBanners = $$('.icon-banner', story);

  if (animatedBanners.length) {
    fadeInFromBottom(animatedBanners);
  }
}
